var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMAnyasis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 3.25,
    fill: "#84E1CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1095 4V22L20.71 18.3355V6.5005L16.1095 4ZM13.9698 18.0685L10.2655 19.6863V5.5645L13.9698 6.661V18.0685ZM5.29077 17.6537L8.12577 16.9045V7.891L5.30427 7.4365L5.29077 17.6537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAnyasis);
export default __webpack_public_path__ + "static/media/MAnyasis.aa3ec4459827191021691e3617bde0f2.svg";
export { ForwardRef as ReactComponent };